import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Solution(props) {
    return (
        <div className="services_solution  p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <div className="example" data-text="Sustainable">
                            <h2>Sustainable, Low-Risk, And Quick-To-Market Solutions</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
                      <p>MVP development is not about building at scale. It is about translating ideas into low-risk products that are easy to develop and quick to market. Shorter sprints, detailed analysis, and directed efforts make it possible to develop a stable product.</p>
                        <p>With calculated steps, we progress by developing and mitigating simultaneously. Soon as the development nears completion, we draft the marketing plans to execute and measure. This continuous process sits on the core foundations that utilize minimum resources and produce maximum results.</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>

                </Row>
            </Container>
        </div>
    );
}

export default Solution;